import { withAITracking } from '@microsoft/applicationinsights-react-js';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { reactPlugin } from 'main/azureInsights/config';
import TitleWrapper from 'main/layout/TitleWrapper';
import { home_HomeUrl } from 'main/routes/urls/RouteUrls';

import { getRandomBackgroundIndex } from './RandomBackground';

const HomeAboutPage = (): React.JSX.Element => {
	const { t } = useTranslation(['home', 'commonButton']);

	return (
		<>
			<TitleWrapper
				category={t('root-title')}
				title={t('about-product-center')}
			/>
			<Grid
				container
				className={
					'homeContent homeContent--' + getRandomBackgroundIndex()
				}
				sx={{
					minHeight: 400,
					width: '100%',
				}}>
				<Grid
					container
					className="homeContent homeContent--overlay"
					sx={{
						width: '100%',
					}}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							width: '100%',
							gap: '40px',
						}}
						className="homeContent homeContent--gradient">
						<Box
							sx={{
								width: '80%',
								alignSelf: 'center',
							}}>
							<Typography
								variant="h2"
								sx={{
									textAlign: 'center',
								}}>
								{t('home:content-label')}
							</Typography>
						</Box>
						<Box
							className="homeContent__text"
							sx={{
								maxWidth: '800px',
								alignSelf: 'center',
								p: 2,
							}}>
							<Typography>{t('home:content-text2')}</Typography>
						</Box>
						<Box
							sx={{
								width: '80%',
								alignSelf: 'center',
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'flex-end',
							}}>
							<Button
								variant="text"
								to={home_HomeUrl}
								component={Link}
								endIcon={<ArrowForward />}
								sx={{
									fontSize: '20px',
								}}>
								{t('commonButton:back')}
							</Button>
						</Box>
					</Box>
				</Grid>
			</Grid>
		</>
	);
};

export default withAITracking(
	reactPlugin,
	HomeAboutPage,
	'HomeAboutPage',
	'application-insight-container'
);
